module.exports = __webpack_public_path__ + "img/award_star.e2896710.svg";